var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFooterbgLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 374.8 398.7"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M357.2 354.9c-39-100-80.6-195.4-159.5-264.1C145 45 76.6 14.2 0 .5v82.3c56.3 12.1 106 35.6 144.6 69.1 65 56.5 102 142.2 137.3 232.7 1.8 4.7 3.7 9.4 5.5 14.1h87.3c-6.1-14.4-11.8-29.2-17.5-43.8"
})));
export default SvgFooterbgLeft;